<template>

    <div class="index">

        <div class="topic">

            <div class="star-nav ">

                <span class="pointer" @click="openIndex">话题</span>

                <span> / </span>

                <span>话题详情</span>

            </div>

            <div class="cf">

                <div class="topic-left fl">

                    <div class="topic-title">{{data.title}}</div>

                    <div v-if="data.type == 3">

                        <div class="topic-subtitle">赢方平分输方的笔芯</div>

                        <div class="topic-pk relative">

                            <img class="absolute topic-icon" src="./images/topic_icon_vs@2x.png" />

                            <div class="topic-pk-box cf">

                                <div class="topic-pk-item fl">

                                    <div class="topic-pk-item-title line1">{{data.red_title}}</div>

                                    <div class="topic-pk-item-img">

                                        <v-image class="topic-pk-item-img-img" :src="data.red_picture" />

                                    </div>

                                    <div class="topic-pk-item-price red-price">{{data.red_price}}笔芯</div>

                                </div>

                                <div class="topic-pk-item fr">

                                    <div class="topic-pk-item-title line1">{{data.blue_title}}</div>

                                    <div class="topic-pk-item-img">

                                        <v-image class="topic-pk-item-img-img" :src="data.blue_picture" />

                                    </div>

                                    <div class="topic-pk-item-price blue-price">{{data.blue_price}}笔芯</div>

                                </div>

                            </div>

                            <div class="progress cf">

                                <div
                                    class="progress-red fl"
                                    :style="{width: red + '%'}"
                                ></div>

                                <div
                                    class="progress-blue fr"
                                    :style="{width: blue + '%'}"
                                ></div>

                            </div>

                            <div class="progress-text">{{ red > blue ? '红方领先' : red === blue ? '双方持平' : '蓝方领先' }}</div>

                            <div class="button topic-btn button-active" @click="openPop">我要参与</div>

                        </div>

                        <div class="count-down">倒计时：{{count_down}}</div>

                    </div>

                    <div v-else-if="data.type == 2">

<!--                        <v-image class="topic-post" :src="data.picture" />-->

                        <div class="topic-content v-html" v-html="data.content"></div>

                        <div class="topic-select">

                            <div class="topic-select-title">{{data.vote_title}}</div>

                            <div
                                class="topic-select-vote cf"
                                v-for="(item,index) in data.vote_star"
                                :key="'topic-vote-'+index"
                            >

                                <div class="fl topic-select-vote-img" @click="changeSelect(item,index)">

                                    <img v-if="selected === index" src="./images/sign_checkbox_s@2x.png"/>

                                    <img v-else src="./images/sign_checkbox_n@2x.png"/>

                                </div>

                                <div class="fl">{{ item }}</div>

                            </div>

                        </div>

                        <div class="vote-btn button button-active" @click="openPop">我要参与</div>

                        <div class="count-down">倒计时：{{count_down}}</div>

                    </div>

                    <div v-else>

<!--                        <v-image class="topic-post" :src="data.picture" />-->

                        <div class="topic-content v-html" v-html="data.content"></div>

                    </div>

                    <div class="news-comment">

                        <div class="news-comment-header cf">

                            <div class="news-comment-header-title fl">评论列表 <span>{{data.comment_count}}</span></div>

                            <div v-if="!$store.state.user.token || !is_login" class="fr news-comment-header-right"><span @click="openLogin">登录</span>后可评论</div>

                        </div>

                        <div class="news-comment-content">

                            <layout-comment-input
                                :id="data.id"
                                :type="5"
                            />

                            <layout-comment-item
                                v-for="(item,index) in comment_list"
                                :key="'topic-comment-item-'+index"
                                :data="item"
                            />

                        </div>

                        <layout-more
                            :status="status"
                            @load="loadInfo"
                        />

                    </div>

                </div>

                <div class="topic-right fr">

                    <layout-right-list :data="info" />

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
import LayoutRightList from '@/layout/layout-right-list/main';
import LayoutCommentInput from '@/layout/layout-comment-input/main';
import LayoutCommentItem from '@/layout/layout-comment-item/main';
import LayoutMore from '@/layout/layout-more/main';
import vImage from '@/components/image';

export default {
    name: "topic-detail",
    mixins: [mixin],
    components: {
        LayoutRightList,
        LayoutCommentInput,
        LayoutCommentItem,
        LayoutMore,
        vImage
    }
}
</script>

<style scoped src="./style.css"></style>
